import Immutable from "immutable";
import keyConverter from "services/key-converter";

const ZendeskDeptRecord = Immutable.Record({
  id: null,
  name: null
});

export const zendeskDepartments = (state = Immutable.List([]), action) => {
  switch (action.type) {
    case "GET_ZENDESK_DEPT_SUCCESS":
      return action.response.data.departments.map(dept => (
        new ZendeskDeptRecord(keyConverter(dept))
      ));
    default:
      return state;
  }
};
